module.exports = __webpack_public_path__ + "static/media/effect_start.d59082d5.png";